import Loadable from "app/components/Loadable";
import { lazy } from "react";

const FarmVisitList = Loadable(lazy(() => import("./FarmVisitList")));
const FarmVisitForm = Loadable(lazy(() => import("./FarmVisitForm")));

const farmVisitRoutes = [
  {
    path: "/FarmVisit/FarmVisitList",
    element: <FarmVisitList />,
  },
  {
    path: "/FarmVisit/FarmVisitForm",
    element: <FarmVisitForm />,
  },
  {
    path: "/FarmVisit/FarmVisitForm/:visitId",
    element: <FarmVisitForm />,
  },
];
export default farmVisitRoutes;
